export default __webpack_public_path__ + "static/media/mepbayThumb.770ffcf1.jpg";